import React from 'react';
import { FeaturedDocsCard } from '@backstage/plugin-home';
import { MicrosoftCalendarCard } from '@backstage-community/plugin-microsoft-calendar';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { Grid } from '@dewise-devex/backstage-plugin-mui-uikit-react';
import { Products } from './Products';
import useAsync from 'react-use/esm/useAsync';

const AgendaAndQuickLinks = () => {
  const identityApi = useApi(identityApiRef);
  const catalogApi = useApi(catalogApiRef);

  const { value: featuredDocs = [], loading } = useAsync(async () => {
    const identity = await identityApi.getBackstageIdentity();
    const userEntity = await catalogApi.getEntityByRef(identity.userEntityRef);

    if (userEntity?.relations) {
      const groups = userEntity.relations
        .filter(relation => relation.type === 'memberOf')
        .map(relation => relation.targetRef);

      return groups.map(group => ({
        'spec.type': 'documentation',
        'spec.owner': group,
      }));
    }

    return [];
  });

  return (
    <>
      <Grid size={{ sm: 12, xs: 12, md: 4 }}>
        <Products />
      </Grid>
      <Grid size={{ sm: 12, xs: 12, md: 4 }}>
        <MicrosoftCalendarCard />
      </Grid>
      <Grid size={{ sm: 12, xs: 12, md: 4 }}>
        {!loading && <FeaturedDocsCard filter={featuredDocs} />}
      </Grid>
    </>
  );
};

export default AgendaAndQuickLinks;
